import translate from 'rcm-i18n';
import React, {Component} from 'react';
import FormattedTotals from './FormattedTotals';

interface Props {
    formattedTotals: FormattedTotals;
    showBvPv: boolean;
}

export default class TotalsComponent extends Component<Props> {
    public render() {
        const formattedTotals = this.props.formattedTotals;
        return (
            <table className="pull-right clearfix"
                   style={{visibility: (formattedTotals.loading ? 'hidden' : 'visible')}}>
                <tbody>
                {this.props.showBvPv &&
                <tr>
                    <td><strong>{translate('BV Total')}:</strong></td>
                    <td>{formattedTotals.bv}</td>
                </tr>
                }
                {this.props.showBvPv &&
                <tr>
                    <td><strong>{translate('PV Total')}:</strong></td>
                    <td>{formattedTotals.pv}</td>
                </tr>
                }
                <tr>
                    <td><strong>{translate('Subtotal')}:</strong></td>
                    <td>{formattedTotals.subTotal}</td>
                </tr>
                </tbody>
            </table>
        );
    }
}
